import { FC, useState } from 'react';

interface SurrenderButtonProps {
  onSurrender: () => void;
  disabled?: boolean;
}

const SurrenderButton: FC<SurrenderButtonProps> = ({ onSurrender, disabled }) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSurrender = () => {
    if (showConfirm) {
      onSurrender();
      setShowConfirm(false);
    } else {
      setShowConfirm(true);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleSurrender}
        disabled={disabled}
        className={`px-4 py-2 rounded ${
          showConfirm
            ? 'bg-red-600 hover:bg-red-700'
            : 'bg-gray-600 hover:bg-gray-700'
        } text-white transition-colors ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        {showConfirm ? 'Confirm Surrender?' : 'Surrender'}
      </button>
      {showConfirm && (
        <button
          onClick={() => setShowConfirm(false)}
          className="absolute top-full left-0 mt-2 px-4 py-2 bg-gray-600 
          hover:bg-gray-700 text-white rounded transition-colors"
        >
          Cancel
        </button>
      )}
    </div>
  );
};

export default SurrenderButton; 